var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportSidebarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8958_106126)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0.5C1.27614 0.5 1.5 0.723858 1.5 1V14.5H15C15.2761 14.5 15.5 14.7239 15.5 15C15.5 15.2761 15.2761 15.5 15 15.5H1.5C1.23478 15.5 0.98043 15.3946 0.792893 15.2071C0.605356 15.0196 0.5 14.7652 0.5 14.5V1C0.5 0.723858 0.723858 0.5 1 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.625 7.5C3.55596 7.5 3.5 7.55596 3.5 7.625V12.375C3.5 12.444 3.55596 12.5 3.625 12.5H4.875C4.94404 12.5 5 12.444 5 12.375V7.625C5 7.55596 4.94404 7.5 4.875 7.5H3.625ZM2.5 7.625C2.5 7.00368 3.00368 6.5 3.625 6.5H4.875C5.49632 6.5 6 7.00368 6 7.625V12.375C6 12.9963 5.49632 13.5 4.875 13.5H3.625C3.00368 13.5 2.5 12.9963 2.5 12.375V7.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.125 6C8.05596 6 8 6.05596 8 6.125V12.375C8 12.444 8.05596 12.5 8.125 12.5H9.375C9.44404 12.5 9.5 12.444 9.5 12.375V6.125C9.5 6.05596 9.44404 6 9.375 6H8.125ZM7 6.125C7 5.50368 7.50368 5 8.125 5H9.375C9.99632 5 10.5 5.50368 10.5 6.125V12.375C10.5 12.9963 9.99632 13.5 9.375 13.5H8.125C7.50368 13.5 7 12.9963 7 12.375V6.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6138 4C12.5447 4 12.4888 4.05596 12.4888 4.125V12.375C12.4888 12.444 12.5447 12.5 12.6138 12.5H13.8638C13.9328 12.5 13.9888 12.444 13.9888 12.375V4.125C13.9888 4.05596 13.9328 4 13.8638 4H12.6138ZM11.4888 4.125C11.4888 3.50368 11.9924 3 12.6138 3H13.8638C14.4851 3 14.9888 3.50368 14.9888 4.125V12.375C14.9888 12.9963 14.4851 13.5 13.8638 13.5H12.6138C11.9924 13.5 11.4888 12.9963 11.4888 12.375V4.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8958_106126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSidebarIcon);
export default __webpack_public_path__ + "static/media/ReportSidebarIcon.a7420d1e.svg";
export { ForwardRef as ReactComponent };